import React from "react";

const EneaCoachingParejas = () => {
  return (
    <section className="section-container">
      <h2>EneaCoaching para Parejas</h2>
      <h3>Fortalece tu Relación y Conecta Más Profundamente con EneaCoaching para Parejas</h3>
      <p>
        Toda relación atraviesa momentos difíciles, pero lo que realmente marca la diferencia es cómo las parejas se enfrentan a esos desafíos. Si sientes que la comunicación con tu pareja no es la ideal, que hay conflictos recurrentes o simplemente deseas fortalecer aún más el vínculo, el EneaCoaching para Parejas puede ser la herramienta que transformará vuestra relación.
      </p>

      <h3>¿Qué es EneaCoaching para Parejas?</h3>
      <p>
        EneaCoaching para Parejas combina el Eneagrama y el Coaching Ontológico para ayudar a las parejas a entenderse mejor, resolver conflictos de manera saludable y fortalecer su relación. Utilizamos el Eneagrama como un mapa de personalidad para comprender los patrones de comportamiento de cada uno, sus motivaciones y cómo interactúan en pareja, y aplicamos el Coaching Ontológico para transformar los bloqueos y fomentar una comunicación abierta, honesta y empática.
      </p>

      <h3>¿Te reconoces en alguna de estas situaciones?</h3>
      <ul>
        <li>Tienes dificultades para comunicarte con tu pareja de manera efectiva.</li>
        <li>Hay conflictos recurrentes que no logras resolver.</li>
        <li>Te gustaría entender mejor las motivaciones y comportamientos de tu pareja para mejorar la relación.</li>
        <li>Sientes que la relación ha perdido parte de la conexión emocional y necesitas redescubrirla.</li>
      </ul>

      <p>
        Si es así, EneaCoaching para Parejas es para ti.
      </p>

      <h3>Lo que conseguirás con el Pack de 10 sesiones:</h3>
      <ul>
        <li>1. Mejor comunicación: A través del Eneagrama, aprenderás a entender mejor los estilos de comunicación y las necesidades emocionales de tu pareja, lo que te permitirá conectar de manera más profunda y evitar malentendidos.</li>
        <li>2. Resolución de conflictos saludables: Con las herramientas del Coaching Ontológico, trabajaremos en cómo abordar y resolver los conflictos de manera constructiva, ayudando a ambos a escuchar y respetar las perspectivas del otro.</li>
        <li>3. Comprensión profunda de los patrones de comportamiento: El Eneagrama te ayudará a identificar los patrones de comportamiento y las dinámicas de poder que pueden estar presentes en la relación. Esto facilitará el entendimiento mutuo y la creación de soluciones prácticas para mejorar la relación.</li>
        <li>4. Fortalecimiento del vínculo emocional: A través de un proceso guiado de autoconocimiento y reflexión, ambos aprenderán a reconectar con el amor y el respeto, creando una relación más sólida y emocionalmente saludable.</li>
        <li>5. Transformación personal y relacional: Las sesiones de EneaCoaching para Parejas no solo mejorarán la relación de pareja, sino que también fomentarán el crecimiento personal de ambos, permitiéndoles ser individuos más conscientes y maduros dentro de la relación.</li>
      </ul>

      <h3>¿Por qué elegir EneaCoaching para Parejas?</h3>
      <ul>
        <li>Enfoque personalizado y profundo: Cada pareja es única, y las sesiones se adaptan específicamente a las necesidades y dinámicas de tu relación.</li>
        <li>Transformación integral: Trabajamos tanto en el autoconocimiento individual como en la relación en pareja, lo que permite una transformación profunda y duradera.</li>
        <li>Herramientas poderosas y comprobadas: El Eneagrama y el Coaching Ontológico son enfoques probados que permiten mejorar la comunicación, resolver conflictos y fortalecer el vínculo emocional.</li>
      </ul>

      <h3>Tu próximo paso:</h3>
      <p>
        El Pack de 10 sesiones de EneaCoaching para Parejas es el acompañamiento perfecto para mejorar tu relación, fortalecer la comunicación y resolver los conflictos de manera constructiva. Juntos, aprenderán a crear una relación más armoniosa, empática y profundamente conectada.
      </p>

      <p><strong>¡No esperes más!</strong></p>

       <button
            className="btn-contacto"
            onClick={() => {
                window.open(
                "https://wa.me/34696667110?text=Hola. Quiero información sobre EneaCoaching para parejas.",
                "_blank"
                );
            }}
            >
            Reserva Ahora tu Pack de 10 Sesiones para Parejas
            </button>
        
    </section>
  );
};

export default EneaCoachingParejas;
